export enum SettingsPermissions {
  ALL = "Travel:Settings:*",
  READ = "Travel:Settings:Read",
  WRITE = "Travel:Settings:Write",
  USERS = "Travel:Settings:Users",
  ROLES = "Travel:Settings:Roles",
}

export function hasSettingsAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [SettingsPermissions.READ, SettingsPermissions.ALL, "*"].includes(p)
  );
}
